module.exports = __webpack_public_path__ + "img/blue_028.5bff1000.png";